module.exports = __webpack_public_path__ + "img/art_logo.c589c6a4.svg";